import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "@tanstack/react-router";
import { type SubmitHandler, useForm } from "react-hook-form";
import { toast } from "sonner";

import { orpc } from "@/client";
import { AuthLabels } from "@/lib/labels";

type ChangeInput = { new_password: string; confirm: string };

export function useChangePassword() {
	const navigate = useNavigate();
	const queryClient = useQueryClient();
	const { mutateAsync } = useMutation(orpc.auth.changePassword.mutationOptions());

	const methods = useForm<ChangeInput>();

	const onSubmit: SubmitHandler<ChangeInput> = async (data) => {
		if (data.new_password.length < 8) {
			methods.setError("new_password", { message: AuthLabels.tooShort });

			return;
		}

		if (data.new_password !== data.confirm) {
			methods.setError("confirm", { message: AuthLabels.mismatch });

			return;
		}

		await mutateAsync({ new_password: data.new_password })
			.then(() => {
				queryClient.clear();

				return navigate({ to: "/", replace: true });
			})
			.catch(() => {
				toast.error(AuthLabels.tooShort);
			});
	};

	return {
		methods,
		handleSubmit: methods.handleSubmit(onSubmit),
	};
}
